/* eslint-disable @typescript-eslint/naming-convention */
import { BatteryFixedVoltages } from 'src/api';

export const batteryComponent: BatteryFixedVoltages = {
  component_type: BatteryFixedVoltages.component_type.BATTERY_FIXED_VOLTAGES,
};
